import { render, staticRenderFns } from "./ViewActivity.vue?vue&type=template&id=287ecfec"
import script from "./ViewActivity.vue?vue&type=script&lang=js"
export * from "./ViewActivity.vue?vue&type=script&lang=js"
import style0 from "./ViewActivity.vue?vue&type=style&index=0&id=287ecfec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports